import { motion, AnimatePresence } from 'framer-motion'
import { useLocation } from 'react-router-dom'
import { MotionTokens } from '../styles/motion-tokens'

export default function RouteTransitionWrapper({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -8 }}
        transition={{
          duration: MotionTokens.enterScene.duration ?? 0.7,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  )
}
